import React from "react";
import { Flex, Text, Box, List, ListItem, Heading } from "@chakra-ui/react";
import { useFetchUserInfo } from "../../hooks/useFetchUserInfo";
import { Organization } from "../Organization";

export const ProfileInfo = ({ user, isTeacher }) => {
  const userInfo = useFetchUserInfo(user);
  return (
    <Box
      style={{
        maxWidth: "1180px",
        margin: "0 auto",
        padding: "30px 20px",
      }}
    >
      <List>
        {React.Children.toArray(
          userInfo.map(({ key, value }) => (
            <ListItem>
              <Flex
                style={{
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Heading as="h5" size="sm" width="50%" margin="0 0 10px">
                  {key}
                </Heading>
                <Text fontSize="sm" width="50%">
                  {value}
                </Text>
              </Flex>
            </ListItem>
          ))
        )}
      </List>
      {isTeacher && <Organization user={user} isTeacher={isTeacher} />}
    </Box>
  );
};
